import { createAsyncThunk } from '@reduxjs/toolkit';

import * as api from 'api/methods';

import * as types from './types';

export const getLessons = createAsyncThunk<any, any>(
  types.GET_LESSONS,
  async (params: Record<string, any>) => {
    const lessons = await api.getLessons(params);

    return lessons;
  },
);
